module.exports = __webpack_public_path__ + "img/tagIconAdd.277a811c.svg";